/**
* 本文件由工具自动生成，请勿手动写入代码，随意修改！！！
* created mengl
* @name Races
* @description 场次管理
*/
import request from '@/plugins/axios.js';

/** 
 * 获取当前进行场次
 */
export const getCurrentRace = () => {
    return request({
        url: '/api/Races/GetCurrentRace',
        method: 'get',
    });
}

/** 
 * 获取可以开始场次列表
 */
export const getStartRaces = () => {
    return request({
        url: '/api/Races/GetStartRaces',
        method: 'get',
    });
}

/** 
 * 所选场次开始
 * @param {Integer} id -  
 */
export const startRace = (id) => {
    return request({
        url: '/api/Races/StartRace',
        method: 'post',
        params:{
            id
        }
    });
}

/** 
 * 所选场次结束
 * @param {Integer} id -  
 */
export const finishRace = (id) => {
    return request({
        url: '/api/Races/FinishRace',
        method: 'post',
        params:{
            id
        }
    });
}

/** 
 * 获取延时场次分页
 * @param {Integer} page -  
 */
export const getDelayRaces = (page) => {
    return request({
        url: '/api/Races/GetDelayRaces',
        method: 'get',
        params:{
            page
        }
    });
}

/** 
 * 获取延时场次分页数量
 */
export const getDelayCountRaces = () => {
    return request({
        url: '/api/Races/GetDelayCountRaces',
        method: 'get',
    });
}

/** 
 * 所选场次延时
 * @param {Integer} id -  
 * @param {Integer} duration -  
 */
export const delayRace = (id, duration) => {
    return request({
        url: '/api/Races/DelayRace',
        method: 'post',
        params:{
            id,
            duration
        }
    });
}

/** 
 * 获取比赛管理
 * @param {Integer} pageIndex - 页索引 
 * @param {Integer} pageSize - 页大小 
 * @param {Integer} classId -  
 * @param {Integer} status - 状态：-1：全部，0：未开始，1：进行中，2：已结束 
 */
export const getRaceManager = (pageIndex, pageSize, classId, status) => {
    return request({
        url: '/api/Races/GetRaceManager',
        method: 'get',
        params:{
            pageIndex,
            pageSize,
            classId,
            status
        }
    });
}

/** 
 * 网店营销与运营推广时间详情
 * @param {Integer} raceId - 场次编号 
 */
export const getOperateDetails = (raceId) => {
    return request({
        url: '/api/Races/GetOperateDetails',
        method: 'get',
        params:{
            raceId
        }
    });
}

/** 
 * 互联网产品开发 - 开始比赛
 * @param {Integer} raceId - 场次编号 
 * @param {Integer} classId -  
 */
export const startProudctDev = (raceId, classId) => {
    return request({
        url: '/api/Races/StartProudctDev',
        method: 'post',
        params:{
            raceId,
            classId
        }
    });
}

/** 
 * 互联网产品开发 - 结束比赛
 * @param {Integer} raceId - 场次编号 
 */
export const endProudctDev = (raceId) => {
    return request({
        url: '/api/Races/EndProudctDev',
        method: 'post',
        params:{
            raceId
        }
    });
}

/** 
 * 互联网产品开发 - 延迟比赛
 * @param {Integer} raceId - 场次编号 
 * @param {Integer} duration - 延时时长 
 * @param {Integer} classId -  
 */
export const delayProudctDev = (raceId, duration, classId) => {
    return request({
        url: '/api/Races/DelayProudctDev',
        method: 'post',
        params:{
            raceId,
            duration,
            classId
        }
    });
}

/** 
 * 店铺装修 - 开始比赛
 * @param {Integer} raceId - 场次编号 
 * @param {Integer} classId -  
 */
export const startStore = (raceId, classId) => {
    return request({
        url: '/api/Races/StartStore',
        method: 'post',
        params:{
            raceId,
            classId
        }
    });
}

/** 
 * 店铺装修 - 结束比赛
 * @param {Integer} raceId - 场次编号 
 */
export const endStore = (raceId) => {
    return request({
        url: '/api/Races/EndStore',
        method: 'post',
        params:{
            raceId
        }
    });
}

/** 
 * 店铺装修 - 延迟比赛
 * @param {Integer} raceId - 场次编号 
 * @param {Integer} duration - 延时时长 
 * @param {Integer} classId -  
 */
export const delayStore = (raceId, duration, classId) => {
    return request({
        url: '/api/Races/DelayStore',
        method: 'post',
        params:{
            raceId,
            duration,
            classId
        }
    });
}

/** 
 * 运营与推广 - 开始比赛
 * @param {Integer} raceId - 场次编号 
 * @param {Integer} classId -  
 */
export const startOperater = (raceId, classId) => {
    return request({
        url: '/api/Races/StartOperater',
        method: 'post',
        params:{
            raceId,
            classId
        }
    });
}

/** 
 * 运营与推广 - 结束比赛
 * @param {Integer} raceId - 场次编号 
 */
export const endOperater = (raceId) => {
    return request({
        url: '/api/Races/EndOperater',
        method: 'post',
        params:{
            raceId
        }
    });
}

/** 
 * 运营与推广 - 暂停比赛
 * @param {Integer} raceId - 场次编号 
 */
export const pauseOperater = (raceId) => {
    return request({
        url: '/api/Races/PauseOperater',
        method: 'post',
        params:{
            raceId
        }
    });
}

/** 
 * 运营与推广 - 继续比赛
 * @param {Integer} raceId - 场次编号 
 */
export const continueOperater = (raceId) => {
    return request({
        url: '/api/Races/ContinueOperater',
        method: 'post',
        params:{
            raceId
        }
    });
}

/** 
 * 运营与推广 - 延时比赛
 * @param {Integer} raceId - 场次编号 
 * @param {Integer} duration - 延时时长，单位分钟 
 */
export const delayOperate = (raceId, duration) => {
    return request({
        url: '/api/Races/DelayOperate',
        method: 'post',
        params:{
            raceId,
            duration
        }
    });
}

